import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'dva';
//import { Modal, Popover, Button, Spin, Row, Col } from 'antd';
import BaseComponent from './BaseComponent';
import NewsPage from '../pages/news/components/NewsPage';
import SalePage from '../pages/travel/components/SalePage';
//import Dimio from './Dimio';

class Dispatcher extends BaseComponent {
  /*
  constructor(props) {
    super(props);
  }
  */

  componentWillMount() {
    const {app, container} = this.props;

    /*
        const apps = document.querySelectorAll(".app");
        if(apps){
          for (let i = 0; i < apps.length; ++i) {
            console.info(apps[i]);

            //ReactDOM.render(<LoadAd store={app._store} {...apps[i].dataset} />, ads[i]);
          }
        }
    */

    if(container.length) {
      for (let i = 0; i < container.length; ++i) {
        console.info(container[i]);

        if(container[i].key == 'news') {
          ReactDOM.render(<NewsPage store={app._store} {...container[i].ds} />, container[i].target);
        }
        if(container[i].key == 'travel') {
          ReactDOM.render(<SalePage store={app._store} {...container[i].ds} />, container[i].target);
        }
      }
    }


  }

  render() {
    return(
      <div>Index Page</div>
    )
  }
}


export default connect(({ meta, container }) => ({
  meta, container
}))(Dispatcher);


// WEBPACK FOOTER //
// ./src/components/Dispatcher.js